export default "/_next/static/chunks/fonts/din-bold-webfont-4767e3ce7cf2e142b05a134b3a0826f4.woff";